import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=5278920c&scoped=true&"
import script from "./Show.vue?vue&type=script&setup=true&lang=js&"
export * from "./Show.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278920c",
  null
  
)

export default component.exports